import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import * as actions from '../actions'
import _ from 'lodash'
import tts from '../lib/webspeechkit-tts'
import validate from 'validate.js'
import routes from '../routes'

const validatorRegistrationData = {
  email: {
    presence: {
      message: "Укажите E-mail.",
      allowEmpty: false
    },
    email: {
      message: "E-mail не валиден."
    },
  },
  password: {
    presence: {
      message: "Укажите пароль.",
      allowEmpty: false
    },
    format: {
      pattern: "^[0-9a-zA-Z!@#$%^&*]+$",
      flags: "i",
      message: "Пароль может содерать латиские буквы, цифры и символы !@#$%^&*"
    },
    length: {
      minimum: 6,
      message: "Пароль должен быть более 6 символов."
    },
  },
  passwordAgain: {
    presence: {
      message: "Укажите пароль повторно.",
      allowEmpty: false
    },
    equality: {
      attribute: "password",
      message: "Пароли не совпадают.",
    },
  },
};

const calcUserWordsStat = (userWords) => {
  const countWords = _.size(userWords);
  const scoreLevel = Math.floor(_.meanBy(userWords, 'score')) || 0;
  const countNewWords = _.filter(userWords, {score: 0}).length;
  const countStudiedWords = _.filter(userWords, (o) => o.score >= 100).length;

  return {countWords, scoreLevel, countNewWords, countStudiedWords};
};

const user = handleActions({
  [actions.userLoginSuccess](state, { payload: { user } }) {
    return { ...state, ...user, isStart: false };
  },
  [actions.userRegistrationSuccess](state, { payload: { user } }) {
    return { ...state, ...user, isStart: false };
  },
  [actions.getProfile](state, { payload: { user } }) {
    return { ...state, ...user, isStart: false };
  },
  [actions.userLoginFailure](state) {
    return { id: null, login: null, isStart: false };
  },
  [actions.userLogoutSuccess](state) {
    return { id: null, login: null, isStart: false };
  },
}, {id: null, login: null, isStart: true});

const loginForm = handleActions({
  [actions.toggleLoginModal](state) {
    const loginModalState = (state.loginModalState === 'close') ? 'open' : 'close';
    return { ...state, loginModalState };
  },
  [actions.updateLogin](state, { payload: { login } }) {
    return { ...state, login };
  },
  [actions.updatePassword](state, { payload: { password } }) {
    return { ...state, password };
  },
  [actions.userLoginRequest](state) {
    return { ...state, isRequest: true };
  },
  [actions.userLoginFailure](state, { payload: { message } }) {
    return { ...state, message, isRequest: false };
  },
  [actions.userLoginSuccess](state) {
    return { ...state, message: '', isRequest: false, loginModalState: 'close' };
  },
}, {loginModalState: 'close', message: ''});

const registrationForm = handleActions({
  [actions.toggleRegistrationModal](state) {
    const registrationModalState = (state.registrationModalState === 'close') ? 'open' : 'close';
    const validation = validate(state, validatorRegistrationData, {fullMessages: false}) || {};
    return { ...state, registrationModalState, validation, email: '', password: '', passwordAgain: ''};
  },
  [actions.updateRegEmail](state, { payload: { email } }) {
    const newState = { ...state, email };
    const validation = validate(newState, validatorRegistrationData, {fullMessages: false}) || {};
    const isValid = Object.keys(validation).length === 0;
    return {...newState, validation, isValid};
  },
  [actions.updateRegPassword](state, { payload: { password } }) {
    const newState = { ...state, password };
    const validation = validate(newState, validatorRegistrationData, {fullMessages: false}) || {};
    const isValid = Object.keys(validation).length === 0;
    return {...newState, validation, isValid};
  },
  [actions.updateRegPasswordAgain](state, { payload: { passwordAgain } }) {
    const newState = { ...state, passwordAgain };
    const validation = validate(newState, validatorRegistrationData, {fullMessages: false}) || {};
    const isValid = Object.keys(validation).length === 0;
    return {...newState, validation, isValid};
  },
  [actions.userRegistrationRequest](state) {
    return { ...state, isRequest: true };
  },
  [actions.userRegistrationFailure](state, { payload: { message } }) {
    return { ...state, message, isRequest: false };
  },
  [actions.userRegistrationSuccess](state) {
    return { ...state, message: '', isRequest: false, registrationModalState: 'close' };
  },
}, {registrationModalState: 'close', message: '', isValid: false, isRequest: false, email: '', password: '', passwordAgain: '', validation: {}});

const sourceTextForm = handleActions({
  [actions.userLoginFailure]() {
    return {sourceText: '', modalSourceTextState: 'close', wordsForAdd: []};
  },
  [actions.updateSourceText](state, {payload: {sourceText}}) {
    return { ...state, sourceText };
  },
  [actions.toggleSourceTextModal](state) {
    const modalSourceTextState = (state.modalSourceTextState === 'close') ? 'open' : 'close';
    return { ...state, modalSourceTextState, sourceText: '', wordsForAdd: [] };
  },
  [actions.sendSourceTextRequest](state) {
    return { ...state, isRequest: true };
  },
  [actions.sendSourceTextFailure](state) {
    return { ...state, isRequest: false };
  },
  [actions.sendSourceTextSuccess](state, {payload: {wordsForAdd}}) {
    wordsForAdd = wordsForAdd.map(e => ({...e, checked: true}));
    return { ...state, isRequest: false, wordsForAdd };
  },
  [actions.addUserWordsRequest](state) {
    return { ...state, isRequest: true };
  },
  [actions.addUserWordsSuccess](state) {
    return {
      ...state,
      isRequest: false,
      modalSourceTextState: 'close',
      sourceText: '',
      wordsForAdd: []
    };
  },
  [actions.checkUserWords](state, {payload: {userWordId}}) {
    const wordsForAdd = state.wordsForAdd.map(
      e => (e.wordId === userWordId) ? ({...e, checked: !e.checked}) : e
    );
    return { ...state, wordsForAdd };
  },
}, {sourceText: '', modalSourceTextState: 'close', wordsForAdd: []});

const studyWords = handleActions({
  [actions.userLoginFailure]() {
    return {soundOn: false, modalStudyWordsState: 'close', userWords: [], studyTask: {}};
  },
  [actions.toggleStudyWordsModal](state) {
    const modalStudyWordsState = (state.modalStudyWordsState === 'close') ? 'open' : 'close';

    let userWordsStat = {};
    if (modalStudyWordsState === 'close') {
      userWordsStat = calcUserWordsStat(state.userWords);
    }

    return { ...state, modalStudyWordsState, ...userWordsStat};
  },
  [actions.userRegistrationSuccess](state) {
    const userWordsStat = calcUserWordsStat(state.userWords);
    return { ...state, ...userWordsStat };
  },
  [actions.getUserWordsRequest](state) {
    const modalStudyWordsState = (state.modalStudyWordsState === 'close') ? 'open' : 'close';
    return { ...state, isRequest: true, modalStudyWordsState };
  },
  [actions.getUserWordsFailure](state) {
    return { ...state, isRequest: false };
  },
  [actions.getUserWordsSuccess](state, {payload: {userWords, studyTask, activity}}) {
    const modalStudyWordsState = 'open';

    let audio;

    if (state.soundOn) {
      audio = new Audio();
      audio.preload = 'auto';
      audio.src = routes.audio(userWords.find(e => studyTask.userWordId === e.userWordId).wordId);
      audio.playbackRate = 0.8;
      audio.play();
    }

    return { ...state, isRequest: false, userWords, studyTask, modalStudyWordsState, activity: activity ? activity : state.activity, currentAudio: audio };
  },
  [actions.handleStudyAnswer](state, {payload: {indexClickedAnwer}}) {
    const variants = state.studyTask.variantsTranslte;
    state.studyTask.isAnswerClicked = true;
    state.studyTask.variantsTranslte = variants.map(
      (e, i) => i === indexClickedAnwer ? {...e, isClicked: true} : e
    );

    return { ...state };
  },
  [actions.updateUserWordScore](state, {payload: {userWordId, score}}) {
    state.userWords[userWordId].score = score;
    const userWords = {...state.userWords};

    return { ...state, userWords };
  },
  [actions.userRegistrationSuccess](state, { payload: { user: { userWords, activity } } }) {
    const userWordsStat = calcUserWordsStat(userWords);

    return { ...state, userWords, ...userWordsStat, activity };
  },
  [actions.userLoginSuccess](state, { payload: { user: { userWords, activity } } }) {
    const userWordsStat = calcUserWordsStat(userWords);

    return { ...state, userWords, ...userWordsStat, activity };
  },
  [actions.addUserWordsSuccess](state, { payload: { userWords, activity } }) {
    const userWordsStat = calcUserWordsStat(userWords);

    return { ...state, userWords, ...userWordsStat, activity };
  },
  [actions.userWordsManageCheckWord](state, { payload: { userWordId } }) {
    const userWords = state.userWords.map(
      word => userWordId === word.userWordId ? {...word, checked: !word.checked} : word
    );

    return { ...state, userWords };
  },
  [actions.userWordsManageSetPagination](state) {
    const userWords = state.userWords.map( word => ({...word, checked: false}) );
    return { ...state, userWords };
  },
  [actions.toggleUserWordsManageModal](state) {
    const userWords = state.userWords.map( word => ({...word, checked: false}) );
    const userWordsStat = calcUserWordsStat(userWords);

    return { ...state, userWords, userWordsStat };
  },
  [actions.deleteUserWordsSuccess](state, {payload: {userWordsIds}}) {
    const userWords = state.userWords.filter(
      word => (userWordsIds.indexOf(word.userWordId) === -1)
    );
    const userWordsStat = calcUserWordsStat(userWords);

    return { ...state, userWords, ...userWordsStat };
  },
  [actions.turnSound](state, {payload: {soundOn}}) {
    let audio;

    if (soundOn) {
      audio = new Audio();
      audio.preload = 'auto';
      audio.src = routes.audio(state.userWords.find(e => state.studyTask.userWordId === e.userWordId).wordId);
      audio.playbackRate = 0.8;
      audio.play();
    }

    return { ...state, soundOn, currentAudio: audio };
  },
}, {soundOn: false, modalStudyWordsState: 'close', userWords: [], studyTask: {}});

const flashMessages = handleActions({
  [actions.userLoginFailure]() {
    return { messages: [] };
  },
  [actions.addUserWordsSuccess](state) {
    const newMessage = {
      type: 'success',
      text: 'Новые слова успешно добавлены.',
      showed: false,
    };

    const messages = [...state.messages, newMessage];

    return { ...state,  messages };
  },
  [actions.hideMessage](state, {payload: {id}}) {
    const messages = state.messages.filter(
      (message, messageId) => messageId !== id
    );

    return { ...state,  messages };
  },
}, { messages: [] });

const userWordsManage = handleActions({
  [actions.userLoginFailure]() {
    return { modalState: 'close', isRequest: false, paginationStep: 14, paginationCur: 0, messages: [] };
  },
  [actions.toggleUserWordsManageModal](state) {
    const modalState = (state.modalState === 'close') ? 'open' : 'close';
    return { ...state,  modalState, paginationCur: 0 };
  },
  [actions.userWordsManageSetPagination](state, { payload: { paginationCur } }) {
    return { ...state, paginationCur };
  },
  [actions.deleteUserWordsRequest](state) {
    return { ...state, isRequest: true };
  },
  [actions.deleteUserWordsSuccess](state, { payload: { message } }) {
    const newMessage = {type: 'success', text: message, showed: false,};
    const messages = [...state.messages, newMessage];
    return { ...state, isRequest: false, messages };
  },
  [actions.deleteUserWordsFailure](state, { payload: { message } }) {
    const newMessage = {type: 'warning', text: message, showed: false,};
    const messages = [...state.messages, newMessage];
    return { ...state, isRequest: false, messages };
  },
  [actions.hideMessageUserWordsManage](state, {payload: {id}}) {
    const messages = state.messages.filter(
      (message, messageId) => messageId !== id
    );

    return { ...state, messages };
  },
}, { modalState: 'close', isRequest: false, paginationStep: 14, paginationCur: 0, messages: [] });

export default combineReducers({
  user,
  loginForm,
  registrationForm,
  sourceTextForm,
  studyWords,
  flashMessages,
  userWordsManage,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js